export const API_ROOT = 'http://chat.msu.ac.th/api'
export const WEB_ROOT = 'http://chat.msu.ac.th'
//export const API_ROOT = 'http://localhost:54456/api'
//export const WEB_ROOT = 'http://localhost:54456'